'use strict';

var fragt = fragt || {};

fragt.filter = fragt.filter || new function () {
    var self = this;
    var classNames = {
        active: 'active',
        headlineActive: "filter__active-text",
        transitionItems: "filter--trans-items",
        animateItems: "filter--animate-items"
    };

    this.init = function (reRunFiltering) {

        var container = document.querySelector('[data-action*="filter"]');

        if (container) {
            if (reRunFiltering) {
                this.filterHandler();
            } else {
                this.dom = {
                    container: container,
                    filters: container.querySelectorAll('[data-filter]'),
                    targetContainer: document.body.querySelector(container.getAttribute('data-target-container'))
                };

                this.activeStateText = this.dom.container.getAttribute('data-active-text');

                if (this.dom.targetContainer) {
                    for (var f = 0; f < this.dom.filters.length; f++) {
                        var filter = this.dom.filters[f];

                        if (filter.tagName === "BUTTON") {
                            filter.addEventListener('click', function (e) {
                                this.filterHandler(e);
                            }.bind(this));
                        }
                    }
                } else {
                    window.console.log("Can't find [data-target-container] on filter container: ", container);
                }
            }
        } else {
            window.console.log("Filter container missing");
        }
    };

    this.setFiltedHeadline = function (activate) {
        var headline = this.dom.container.parentNode.querySelector('h1');
        var span = headline.querySelector("." + classNames.headlineActive);

        if(activate) {
            if(!span) {
                var activeTextElem = document.createElement("span");
                activeTextElem.className = classNames.headlineActive;
                activeTextElem.innerText = this.activeStateText;
                headline.appendChild(activeTextElem);
            }
        } else {
            if(span) {
                headline.removeChild(span);
            }
        }

    };
    /**
     * Filter function that compares selected filter values with filter-values on filter-item.
     * Added hidden-class to items that hasn't got the selected filter value.     
     * @param {object} e - 'Click' or 'Change' event object
     */
    this.filterHandler = function(e) {
        var filter = e ? e.target : false;
        var items = this.dom.targetContainer.querySelectorAll('[data-filter-value]');
        var shownItems = 0;

        if(filter) {
            this.dom.targetContainer.classList.add(classNames.transitionItems);
            if(!filter.classList.contains(classNames.active)) {
                filter.classList.add(classNames.active);
            } else {
                filter.classList.remove(classNames.active);
            }
        }

        var filterValues = this.getSetValues(this.dom.filters);
        
        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            var itemFilterValues = item.getAttribute('data-filter-value').split(',');
            var showItem = false;
            item.removeAttribute("style");

            if(filterValues.length) {
                filterValues.forEach(function(value) {
                    if (itemFilterValues.indexOf(value) !== -1) {
                        showItem = true;
                        shownItems++;
                    }
                });
            } else {
                showItem = true;
                shownItems++;
            }

            item.setAttribute("style", "transition-delay: " + (shownItems * 0.03 + "s;"));

            if (!showItem) {
                item.classList.add('hidden');
            } else {
                item.classList.remove('hidden');
            }
        }

        if(filterValues.length) {
            this.setFiltedHeadline(true);
        } else {
            this.setFiltedHeadline(false);
        }

        if(filter) {
            setTimeout(function() {
                self.dom.targetContainer.classList.add(classNames.animateItems);
            }, 200);

            setTimeout(function(){
                self.dom.targetContainer.classList.remove(classNames.transitionItems);
            }, 500);
        }


        if (shownItems < parseInt(fragt.newsListView.ipp) && fragt.newsListView.hasNextPage === "True") {
            fragt.newsListView.loadMore();
        }
    };

    this.getSetValues = function(filters) {
        var valArray = [];

        // loop through list of filters
        for (var i = 0, len = filters.length; i < len; i++) {

            var filter = filters[i];

            if (filter.tagName === "SELECT") {
                if (filter.value !== "*" && filter.value !== "") {
                    valArray.push(filter.value);
                }
            } else if(filter.tagName === "BUTTON") {
                if(filter.classList.contains(classNames.active)) {
                    valArray.push(filter.getAttribute('data-filter'));
                }
            } else {
                if (filter.checked) { // radio checked?
                    valArray.push(filter.value); // if so, add its value to array
                }
            }
        }
        return valArray; // return value of checked radio or undefined if none checked
    };
}();
